import { render } from "./FirmaUnsPage.vue?vue&type=template&id=a674743a&scoped=true"
import script from "./FirmaUnsPage.vue?vue&type=script&lang=js"
export * from "./FirmaUnsPage.vue?vue&type=script&lang=js"

import "./FirmaUnsPage.vue?vue&type=style&index=0&id=a674743a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a674743a"]])

export default __exports__